window.theme.section('detalhes-medico', el => {
	const btnAgendar = el.querySelector('.js-open-sidebar');
	const modalPayment = el.querySelector('.js-modal-pagamento');
	const sidebarOverlay = el.querySelector('.js-sidebar-overlay');
	
	if (sidebarOverlay) {
		const sidebar = sidebarOverlay?.querySelector('.sidebar');
		const totalPriceEl = sidebar?.querySelector('.js-total-price');
		const openPaymentBtn = sidebar?.querySelector('.js-open-modal-pagamento');
		const btnCloseSidebar = sidebar?.querySelector('.js-close-sidebar');
		const searchInput = sidebar?.querySelector('.js-procedimentos-filter input[name="s"]');
		const selectedWrapper = sidebar?.querySelector('.js-selected-procedimentos');
		const sidebarBody = sidebar?.querySelector('.js-sidebar-body');
		const procedimentosCheckbox = sidebarBody?.querySelectorAll('.js-procedimento');
		
		if (sidebar) {

			btnCloseSidebar.addEventListener('click', closeSidebar);

			btnAgendar?.addEventListener('click', () => {
				openSidebar();
			});

			if (openPaymentBtn) {
				openPaymentBtn.addEventListener('click', e => {
					e.preventDefault();
					e.stopPropagation();

					const selected = selectedWrapper.querySelectorAll('.js-procedimento:checked');

					if (selected.length > 0) {
						closeSidebar();
						helper.openModal(modalPayment);
					} else {
						helper.logMessage('Selecione pelo menos um procedimento', 'warning');
					}
				});
			}

			if (procedimentosCheckbox) {
				procedimentosCheckbox.forEach(checkbox => {
					checkbox.addEventListener('change', () => {
						if (checkbox.checked) {							
							addToSelected(checkbox);
						} else {
							removeFromSelected(checkbox);
						}
					});
				});
			}

			if (searchInput) {
				searchInput.addEventListener('input', event => {
					helper.debounce(filterProcedimentos.apply(this, [event.target.value]), 500);
				}); 
			}

			function closeSidebar() {
				sidebarOverlay.classList.remove('opacity-100');
				sidebar.style.transform = 'translateX(100%)';
				setTimeout(() => {
					sidebarOverlay.classList.add('hidden');
				}, 300);
			}
	
			function openSidebar() {
				sidebarOverlay.classList.remove('hidden');
				const procedimentos = sidebarBody.querySelector('.js-procedimentos-list');
	
				if (procedimentos) {
					const loadProcedimentos = typeof carregarProcedimentos === 'function' && carregarProcedimentos(true);
	
					if (loadProcedimentos) {
						loadProcedimentos.then(() => {
							setTimeout(() => {
								sidebarOverlay.classList.add('active');
								sidebar.style.transform = 'translateX(0)';
							}, 10);
						});
					} else {
						setTimeout(() => {
							sidebarOverlay.classList.add('active');
							sidebar.style.transform = 'translateX(0)';
						}, 10);
					}
				} else {
					setTimeout(() => {
						sidebarOverlay.classList.add('active');
						sidebar.style.transform = 'translateX(0)';
					}, 10);
				}
	
				updateTotal();
			}
	
			function updateTotal () {
				const procedimentosSelecionados = selectedWrapper.querySelectorAll('.js-procedimento:checked');
				let total = 0;
	
				if(procedimentosSelecionados.length === 0) {
					openPaymentBtn?.setAttribute('disabled', true);
				} else {
					procedimentosSelecionados.forEach(cb => {
						total += parseFloat(cb.dataset.price || 0);
					});
	
					openPaymentBtn?.removeAttribute('disabled');
				}
	
				totalPriceEl.textContent = helper.formatPrice(total);
			}
	
			function addToSelected (checkbox) {
				const id = checkbox.value;	
				const label = checkbox.closest('.js-procedimento-item');
				const clone = label.cloneNode(true);
				const cloneInput = clone.querySelector('input');
				cloneInput.checked = true;
		
				cloneInput.addEventListener('change', () => {
					clone.remove();
					sidebar.querySelector(`input[value="${id}"]`).checked = false;
					updateTotal();
				});
		
				selectedWrapper.appendChild(clone);
				updateTotal();
			};
	
			function removeFromSelected (checkbox) {
				const id = checkbox.value;
				const clone = selectedWrapper.querySelector(`input[value="${id}"]`);
		
				if (clone) {
					clone.closest('.js-procedimento-item').remove();
					updateTotal();
				}
			};
	
			// Filtro de busca no accordion
			function filterProcedimentos(term) {
				term = term.toLowerCase();

				if (term.length) {
					sidebarBody.classList.add('searching');
				} else {
					sidebarBody.classList.remove('searching');
				}
	
				const items = sidebarBody.querySelectorAll('.js-procedimento-item');
				items.forEach(item => {
					const label = item.querySelector('label');
					const title = label.querySelector('.heading-small')?.textContent.toLowerCase();
					item.style.display = title.includes(term) ? 'block' : 'none';
				});
			};
	
			/* async function carregarProcedimentos(reset = false) {
				if (reset) page = 1; // Reseta a paginação
		
				let search = el.querySelector(".js-procedimentos-filter");
	
				if (search) {
					search = helper.serializeForm(search);
				}
	
				try {
					const response = await $.ajax({
						url: `${config.ajax_url}`,
						type: "POST",
						data: {
							action: "get_procedimentos_medico",
							page: page,
							...search
						},
						complete: function(xhr) {
							// const totalPages = xhr.getResponseHeader("X-WP-TotalPages") 
							// 	? parseInt(xhr.getResponseHeader("X-WP-TotalPages")) 
							// 	: NaN;
		
							// if (page < totalPages) {
							// 	$(".js-load-more").removeClass('hidden');
							// } else {
							// 	$(".js-load-more").addClass('hidden');
							// }
						}
					});
		
					if (response && response.success) {
						if (reset) {
							$(".js-procedimentos-list").html(response);
						} else {
							$(".js-procedimentos-list").append(response);
						}
					} else {
						$(".js-procedimentos-list").html(
							`<p class="text-center">Nenhum resultado encontrado com os filtros aplicados.</p>`
						);
						// $(".js-load-more").addClass('hidden');
					}
	
					return true;
				} catch (error) {
					console.error(error);
					$(".js-procedimentos-list").html(
						`<p class="text-center">Erro ao carregar procedimentos: ${error.message}</p>`
					);
					// $(".js-load-more").removeClass('hidden');
				}
			} */
		}
		
	}
});